import Cookies from 'js-cookie'
import { RUNTIME_ENV } from '@/constants/environment'

const SENSORS_ENV = ['omg', 'production', 'beta'].includes(RUNTIME_ENV) ? 'production' : 'default'

const createScriptAndAppendToBody = (src: string) => {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.src = src

  document.body.appendChild(script)
  return script
}

export const baidu = () => {
  // dm: ["xiaoman.cn", "exp.xiaoman.cn"],
  createScriptAndAppendToBody('//hm.baidu.com/hm.js?925e072f764b8f193431ee7c9099e6f5')

  // dm: ["crm.xiaoman.cn"],
  createScriptAndAppendToBody('//hm.baidu.com/hm.js?70f5e1eeec2ad1e9ad4430afacfe1d29')
}

export const sensorsData = () => {
  const sensorsScript = createScriptAndAppendToBody(
    'https://cfile.xiaoman.cn/v5/res/web/sensorsdata/sensorsdata.1.23.2.min.js',
  )
  sensorsScript.onload = function() {
    window.sensors = window.sensorsDataAnalytic201505

    if (!window.sensors) {
      return
    }

    window.sensors.init({
      server_url: `https://datasink-sensorsdata.xiaoman.cn/sa?project=${SENSORS_ENV}`,
      is_track_single_page: true,
      show_log: true,
      send_type: 'beacon',
      get_vtrack_config: true,
      heatmap: {
        //default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
        clickmap: 'default',
        //default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭。
        scroll_notice_map: 'defalut',
        collect_tags: {
          div: {
            max_level: 3,
          },
        },
      },
    })

    const user_id = Cookies.get('userId')

    // 设置公共属性
    window.sensors.registerPage?.({ platform_type: 'WEB' })

    if (user_id) {
      window.sensors.login?.(user_id)
    }

    window.sensors.use?.('PageLoad')
    if (window.sensorsTempData?.length) {
      window.sensorsTempData.forEach(({ event, data }) => {
        window.sensors.track(event, data)
      })
      window.sensorsTempData = null
    }
  }
}

export const setupThirdPartyStatistics = () => {
  const statistics = [baidu]
  statistics.forEach(fn => fn())
}
